import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./AcquinPopup.module.css";

const contentData = {
  uz: {
    badge: "Xalqaro akkreditatsiya",
    title: "ACQUIN tomonidan institutsional akkreditatsiyadan o‘tgan",
    description:
      "Renessans universiteti O‘zbekiston nodavlat oliy ta’lim muassasalari orasida birinchi bo‘lib, ACQUIN xalqaro akkreditatsiya tashkilotining institutsional akkreditatsiyasidan muvaffaqiyatli o‘tdi.",
  },
  en: {
    badge: "International Accreditation",
    title: "Institutionally accredited by ACQUIN",
    description:
      "Renessans University has become the first private higher education institution in Uzbekistan to successfully obtain institutional accreditation from the international accreditation agency ACQUIN.",
  },
  ru: {
    badge: "Международная аккредитация",
    title: "Институционально аккредитован организацией ACQUIN",
    description:
      "Университет Renessans стал первым негосударственным высшим учебным заведением Узбекистана, успешно прошедшим институциональную аккредитацию международного аккредитационного агентства ACQUIN.",
  },
};

export const AcquinPopup = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);
  const [isClosing, setIsClosing] = useState(false);
  const [activeLang, setActiveLang] = useState("uz");

  useEffect(() => {
    const currentLang = (i18n?.language || "uz").toLowerCase();
    if (contentData[currentLang]) {
      setActiveLang(currentLang);
    } else if (currentLang.startsWith("ru")) {
      setActiveLang("ru");
    } else if (currentLang.startsWith("en")) {
      setActiveLang("en");
    } else {
      setActiveLang("uz");
    }
  }, [i18n?.language]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
    }, 300);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!isOpen) return null;

  const content = contentData[activeLang] || contentData.uz;

  return (
    <div
      className={`${styles.overlay} ${isClosing ? styles.fadeOut : styles.fadeIn}`}
      onClick={handleClose}
    >
      <div
        className={`${styles.modalContainer} ${isClosing ? styles.scaleDown : styles.scaleUp}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={styles.closeBtn}
          onClick={handleClose}
          aria-label="Close"
        >
          &times;
        </button>

        <div className={styles.progressBarContainer}>
          <div className={styles.progressBar} />
        </div>

        <div className={styles.contentWrapper}>
          <div className={styles.logoWrapper}>
            <img
              src={process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/logo-acquin.png` : "/logo-acquin.png"}
              alt="ACQUIN Logo"
              className={styles.logo}
            />
          </div>

          <div className={styles.badge}>{content.badge}</div>

          <h3 className={styles.title}>{content.title}</h3>
          <p className={styles.description}>{content.description}</p>
        </div>
      </div>
    </div>
  );
};

export default AcquinPopup;
